<div id="employee-profile-mobile" class="h-100">

  <div>
    <kl-profile-basic-details-edit (closeDialog)="ok()"></kl-profile-basic-details-edit>
  </div>

</div>
